import axios from 'axios';

import { getAuthorizationProvider } from '../Authentication';

export const authorizedApiClient = axios.create({
  timeout: 60000,
});

const addRequestInterceptors = () => {
  const beforeRequest = async (config) => {
    var authorizationProvider = await getAuthorizationProvider();
    var accounts = authorizationProvider.getAllAccounts();    
    var msalAccount = accounts && accounts.length > 0 ? accounts[0] : '';
    let scopes = authorizationProvider.controller.config.auth.scopes;

    try {
      const response = await authorizationProvider.acquireTokenSilent({ scopes: scopes, account: msalAccount });
      config.headers.Authorization = `Bearer ${response.accessToken}`;
      return config;
    } catch (error) {
      authorizationProvider.acquireTokenRedirect({ scopes: scopes });
    }
  };

  authorizedApiClient.interceptors.request.use(beforeRequest);
};

const addResponseInterceptors = () => {
  authorizedApiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.code === 'ECONNABORTED' && error.message.includes('timeout')) {
        error.message =
          'The server is temporarily taking longer to respond. Please wait a moment and try again.';
      }
      return Promise.reject(error);
    },
  );
};

export const configureInterceptors = () => {
  addRequestInterceptors();
  addResponseInterceptors();
};
